import emptyFieldValidate from "@validators/shared/empty.validate";
import { textLength } from "@validators/shared/textLength.validate";

export type TErrors = {
  name: string | undefined;
  imageUrl: string | undefined;
  order: string | undefined;
  description: string | undefined;
};

const partnerValidate = (FormValues: Record<string, any>) => {
  let errors: TErrors = {
    name: undefined,
    imageUrl: undefined,
    order: undefined,
    description: undefined,
  };

  errors.name = emptyFieldValidate(FormValues.name, "Name");
  errors.name = textLength(FormValues.name, "Name", 100);
  errors.order = emptyFieldValidate(FormValues.order, "Order");
  errors.description = emptyFieldValidate(
    FormValues.description,
    "Description"
  );
  errors.description = textLength(FormValues.description, "Description", 200);
  errors.imageUrl = emptyFieldValidate(FormValues.imageUrl, "Logo");

  return errors;
};

export default partnerValidate;
